// Piano Night route constants keep legacy and standalone entry links consistent.
// ============================================================

export const PIANO_NIGHT_PATH = '/piano-night'
export const LEGACY_PIANO_PATH = '/#/piano'
